






















































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import requestService from "@/service/requestService";
import { MESSAGE } from "@/model/Message";
import { Utils } from "@/service/util";
import { ElInput } from "element-ui/types/input";
@Component({
  components: {
    Header
  }
})
export default class QuickMitsumoriListComponent extends Vue {
  @Prop() torokubangoSelected = "";
  kbnJidousha: any = [];
  data: any = [];
  dataPageList: any = [];
  currentPage = 1;
  pageSize = 10;
  currentRow: any = {};
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  public reqService: requestService = new requestService();
  public utils: Utils = new Utils();

  form: any = {
    searchFrom: null,
    searchTo: null,
    plateNo: null,
    kokyakuNm: null,
    quickMitsumoriId: null
  };

  $refs!: {
    refIptPlateNo: ElInput
  };

  created() {
    this.$set(this, "loading", true);
    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
        this.$set(this, "loading", false);
        this.searchQuick(this.form);
      },
      (err: any) => {
        this.$set(this, "loading", false);
      }
    );
  }

  updated() {
    // console.log("QuickMitsumoriListComponent.updated => CALL !!!");
  }

  destroyed() {
    this.currentRow = {};
    this.data = [];
  }

  setDataPage() {
    const iStart = (this.currentPage - 1) * this.pageSize;
    const iStop = iStart + this.pageSize;
    const data = this.data.slice(iStart, iStop);
    this.$set(this, "dataPageList", data);
  }

  getJADate(date: string) {
    if (date) {
      let str = this.utils.getJapanDate(date, "YYYYMMDD HH:mm:ss");
      // return str.replace(" ", "<wbr/>");
      return str;
    }
    return "";
  }

  onSelect(row: any) {
  }

  handleCurrentChange() {
    this.setDataPage();
  }

  onConfirm() {
    this.$router.push({ name: "quickseibilist" });
    this.data = [];
  }

  onRowSelect(row: any, event: any, column: any) {
    if (this.torokubangoSelected !== row.sknQuickMitsumoriId) {
      // this.torokubangoSelected = row.torokubango;
      this.$emit("onSelectCurrentRow", row);
    } else {
      this.$emit("onSelectCurrentRow");
      // this.torokubangoSelected = "";
    }
  }

  tableRowClassName(item: any) {
    if (
      item.row.sknQuickMitsumoriId === this.torokubangoSelected &&
      this.torokubangoSelected != ""
    ) {
      return "row-selected";
    }
    return "";
  }

  getTorokuBango(row: any) {
    return row.srPlateAreaNm
                     + " " + row.srPlateModelNm
                     + " " + row.srPlateKanaNm
                     + " " + row.srPlateNo;
  }

  getCusomerNm(row: any) {
    if ( row.carSelectionCustomerReq.kkKbn === 1 ) {
      return (row.carSelectionCustomerReq.kojinNmKjSei != null && row.carSelectionCustomerReq.kojinNmKjSei!="") ? 
        row.carSelectionCustomerReq.kojinNmKjSei + "　" + row.carSelectionCustomerReq.kojinNmKjMei + "　様": "上様";
    }
    if ( row.carSelectionCustomerReq.kkKbn === 2 ) {
      return (row.carSelectionCustomerReq.hojinNmKj != null && row.carSelectionCustomerReq.hojinNmKj!="") ? 
        row.carSelectionCustomerReq.hojinNmKj : "上様";
    }

    return "上様";
  }

  getKokusanKbn(row: any) {
    return (row.isImportKbn == 2) ? "輸入車" : "国産";
  }

  getKbnJidousha(row: any) { 
    // 可能であれば数値で比較して抽出する
    let rslt = this.kbnJidousha.filter((e: any) => +e.kbnKey == +row.carSelectionReq.jidoushaShubetsu);
    return (rslt) ? rslt[0].value : "";
  }

  onSearchQuickPlateNo() {
    let searchForm = this.utils.deepCopy(this.form);
    searchForm.kokyakuNm = null;
    searchForm.quickMitsumoriId = null;
    searchForm.searchFrom = null;
    searchForm.searchTo = null;
    this.searchQuick(searchForm);
  }

  onSearchQuickKokyakuNm() {
    let searchForm = this.utils.deepCopy(this.form);
    searchForm.plateNo = null;
    searchForm.quickMitsumoriId = null;
    searchForm.searchFrom = null;
    searchForm.searchTo = null;
    this.searchQuick(searchForm);
  }

  onSearchQuickQuickMitsumoriId() {
    let searchForm = this.utils.deepCopy(this.form);
    searchForm.plateNo = null;
    searchForm.kokyakuNm = null;
    searchForm.searchFrom = null;
    searchForm.searchTo = null;
    this.searchQuick(searchForm);
  }

  onSearchQuick() {
    let searchForm = this.utils.deepCopy(this.form);
    searchForm.plateNo = null;
    searchForm.kokyakuNm = null;
    searchForm.quickMitsumoriId = null;
    this.searchQuick(searchForm);
  }

  searchQuick(form: any) {
    this.$set(this, "loading", true);
    this.reqService.getQuickMitsumoriList(form).then((response: any)=> {
      if (response) {
        this.data = response;
        this.setDataPage();
      }
      this.$set(this, "loading", false);
    },
    (err: any) => {
      this.data = [];
      this.setDataPage();
      this.$set(this, "loading", false);
    });
  }

  focus() {
    this.$refs.refIptPlateNo.focus();
  }
}
